module.exports = __webpack_public_path__ + "static/media/smile-inactive.aaf5a910.svg";